import { Typography, Box } from '@mui/material';
import { UseTableCellProps } from 'react-table';
import { FormattedNumber } from 'shared/controls';

export function DiffingTierColumn<T extends object>({ row, value, column }: UseTableCellProps<T>) {
  const diffingValue = column.id === 'floor' ? row.values.diffingFloor : row.values.diffingRebate;
  const suffix = column.percent ? '%' : '';
  const prefix = !column.percent ? '$' : '';
  const decimalScale = column.percent ? 3 : 2;

  const correctFormatValue = column.percent ? Number(value * 100) : value;
  const correctFormatDiffingValue = column.percent ? Number(diffingValue * 100) : diffingValue;

  const isValuesSame = correctFormatValue === correctFormatDiffingValue;

  return isValuesSame ? (
    <Typography variant='body2'>
      <FormattedNumber
        value={correctFormatValue}
        suffix={suffix}
        prefix={prefix}
        fixedDecimalScale
        decimalScale={decimalScale}
      />
    </Typography>
  ) : (
    <Box sx={{ display: 'inline-flex', gap: '10px' }}>
      <Typography sx={{ textDecoration: 'line-through' }} variant='body2'>
        <FormattedNumber
          value={correctFormatDiffingValue}
          prefix={prefix}
          suffix={suffix}
          fixedDecimalScale
          decimalScale={decimalScale}
        />
      </Typography>
      <Typography variant='body2'>
        <FormattedNumber
          value={correctFormatValue}
          prefix={prefix}
          suffix={suffix}
          fixedDecimalScale
          decimalScale={decimalScale}
        />
      </Typography>
    </Box>
  );
}
